module.exports = __webpack_public_path__ + "media/icon/icon-map-35516e99.svg";